export default __webpack_public_path__ + "static/media/ic_avalanche_96.a5a821af.svg";